module.exports = __webpack_public_path__ + "img/csv.b14e14d3.svg";